export const environment = {
  production: false,
  apiUrl: 'https://back.flashcards.securitycodesystem.cloud/api' // URL LOCAL AQUI
};